import Head from 'next/head'
import { parseHTML } from '../helpers/utils'
import Script from 'next/script'
import { OptinMonsterEmbed } from './OptinEmbed'
import BingAds from './BingAds'
import { useState, useEffect } from 'react'

function ShallowHeader({
    meta,
    metaTitle,
    title,
    renderScripts = true,
    renderMeta = true,
}) {
    title = title || meta?.title

    // Split the string into lines, filter out the unwanted tag, then join back into a string
    meta = String(meta)
        .split('\n')
        .filter(
            (line) =>
                !(
                    line.includes('meta name="robots"') &&
                    line.includes('noindex')
                ),
        )
        .join('\n')

    const [refUrl, setRefUrl] = useState('')

    useEffect(() => {
        if (typeof document !== 'undefined') {
            setRefUrl(encodeURIComponent(document.URL))
        }
    }, [])

    return (
        <>
            {renderMeta && (
                <Head>
                    <link
                        rel="icon"
                        href="/cropped-Favicon-32x32.png"
                        sizes="32x32"
                    />
                    <link
                        rel="icon"
                        href="/cropped-Favicon-192x192.png"
                        sizes="192x192"
                    />
                    <link
                        rel="apple-touch-icon"
                        href="/cropped-Favicon-180x180.png"
                    />
                    <meta
                        name="msapplication-TileImage"
                        content="/cropped-Favicon-270x270.png"
                    />
                    {meta && parseHTML(meta)}
                    {(title || metaTitle) && (
                        <title>{metaTitle || title}</title>
                    )}
                    <link
                        rel="preload"
                        href="/fonts/autopen_print_-_lexi-webfont.woff"
                        as="font"
                        crossOrigin=""
                    />
                    <link
                        rel="preload"
                        href="/fonts/autopen_print_-_lexi-webfont.woff2"
                        as="font"
                        crossOrigin=""
                    />
                    <link
                        rel="preload"
                        href="/fonts/autopen_cursive_-_rose-webfont.woff"
                        as="font"
                        crossOrigin=""
                    />
                    <link
                        rel="preload"
                        href="/fonts/autopen_cursive_-_rose-webfont.woff2"
                        as="font"
                        crossOrigin=""
                    />

                    <Script
                        id="fullcontact-script"
                        strategy="beforeInteractive"
                        dangerouslySetInnerHTML={{
                            __html: "(function (w, d, s, o, f, js, fjs) { w['FCObject'] = o; w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) }; js = d.createElement(s), fjs = d.getElementsByTagName(s)[0]; js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs); }(window, document, 'script', 'fc', 'https://tags.fullcontact.com/anon/fullcontact.js')); var config = { callback: function (pid) { /* Add your js callback code here */ }}; fc('init',\"bOABDbYl1ipQX1NTJ5qsiHRHoGTlr6oq\",config);",
                        }}
                    />
                </Head>
            )}
            {renderScripts && (
                <>
                    <noscript>
                        <iframe
                            src="https://www.googletagmanager.com/ns.html?id=GTM-P586MBT"
                            height="0"
                            width="0"
                            style={{
                                display: 'none',
                                visibility: 'hidden',
                            }}></iframe>
                    </noscript>
                    <Script
                        id="gtm-script"
                        strategy="afterInteractive"
                        dangerouslySetInnerHTML={{
                            __html: `
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-P586MBT');
                    `,
                        }}
                    />
                    <Script
                        id="hs-script-loader"
                        async
                        defer
                        src="//js.hs-scripts.com/21994206.js"
                        onError={(e) => {
                            console.error('Script failed to load', e)
                        }}
                    />
                    <Script
                        strategy="lazyOnload"
                        src="https://www.googletagmanager.com/gtag/js?id=UA-71761379-1"
                        onError={(e) => {
                            console.error('Script failed to load', e)
                        }}
                    />
                    <Script
                        strategy="lazyOnload"
                        onError={(e) => {
                            console.error('Script failed to load', e)
                        }}>
                        {' '}
                        {`
                    window.__lo_site_id = 283820;
                    (function() {
                        var wa = document.createElement('script'); wa.type = 'text/javascript'; wa.async = true;
                        wa.src = 'https://d10lpsik1i8c69.cloudfront.net/w.js';
                        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wa, s);
                    })();`}
                    </Script>

                    <Script
                        strategy="lazyOnload"
                        onError={(e) => {
                            console.error('Script failed to load', e)
                        }}>
                        {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'UA-71761379-1', {
                    page_path: window.location.pathname,
                    });
                `}
                    </Script>

                    <Script
                        async
                        strategy="lazyOnload"
                        src="https://www.googletagmanager.com/gtag/js?id=AW-10868336784"
                        onError={(e) => {
                            console.error('Script failed to load', e)
                        }}
                    />
                    <Script>
                        {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'AW-10868336784');
                `}
                    </Script>

                    <Script id="thoughtmetric-script">
                        {`
                    !function(t,e,i){if(!t.thoughtmetric){t.thoughtmetricQueue=t.thoughtmetricQueue||[],t.thoughtmetric=t.thoughtmetric||function(){t.thoughtmetricQueue.push(arguments)};var u=e.createElement("script");u.async=!0,u.src="https://dn1t7m.admin.openlettermarketing.com/tmpixel.min.js";var h=e.getElementsByTagName("script")[0];h.parentNode.insertBefore(u,h)}}(window,document); thoughtmetric("init","ID-18f99c813e4f0586"); thoughtmetric("proxy","dn1t7m.admin.openlettermarketing.com"); thoughtmetric("pageview");
                `}
                    </Script>

                    {refUrl && (
                        <Script
                            id="hyros-script"
                            type="text/javascript"
                            src={`https://207240.t.hyros.com/v1/lst/universal-script?ph=27c660b4479ef8654ef4a8a024aca9be0fd97e91d328ac63e6d902ec87750496&tag=!clicked&ref_url=${refUrl}`}
                            strategy="afterInteractive"
                        />
                    )}

                    <OptinMonsterEmbed />
                    <BingAds />
                </>
            )}
        </>
    )
}

export default ShallowHeader
